import { mapFirmFromDto } from '@entities/firm';

import type { UserDto } from '../dto';
import type { User } from '../models';
import { mapRoleFromDto } from './role-from-dto';

export function mapUserFromDto(dto: UserDto): User {
  return {
    id: dto.id,
    firstName: dto.first_name,
    lastName: dto.last_name,
    email: dto.email,
    active: dto.active,
    verified: dto.verified,
    emailVerifiedAt: new Date(dto.email_verified_at),
    role: mapRoleFromDto(dto.role),
    firm: dto.firm ? mapFirmFromDto(dto.firm) : null,
  };
}
